const e = "_container_rwm9s_1", n = "_underline_rwm9s_7", s = "_labelText_rwm9s_12", t = "_labelDescription_rwm9s_23", r = "_asteriskIcon_rwm9s_30", l = {
  container: e,
  underline: n,
  labelText: s,
  labelDescription: t,
  asteriskIcon: r
};
export {
  r as asteriskIcon,
  e as container,
  l as default,
  t as labelDescription,
  s as labelText,
  n as underline
};
//# sourceMappingURL=Label.module.css.js.map
